module.exports = __webpack_public_path__ + "img/logo.198c6b78.png";